import { parse } from 'date-fns';

// creates a date at mid day UTC from a string with format YYYY-MM-DD
const createDateAtMidDay = (initialDate: string): Date => {
  const date = parse(`${initialDate}12:00:00Z`, 'yyyy-MM-ddHH:mm:ssX', new Date(Date.now()));
  return date;
};

export default createDateAtMidDay;
